<div *ngIf="(loggedIn && !landingScreen) || requriedActions">
    <mat-toolbar color="primary" class="mat-elevation-z4" *ngIf="showHeader">
        <button mat-icon-button class="example-icon" (click)="sidebarAction()" aria-label="Example icon-button with menu icon">
            <mat-icon>menu</mat-icon>
        </button>
        <span class="vline-devider"></span>
        <span class="logo" style="cursor: pointer;" (click)="navigateToPage('home')"><img src="../assets/images/logo.svg" alt="Vassar Digital" class="logo"></span>
        <span class="spacer"></span>
        <div class="app-Name"  *ngIf="applicationNameDisplay" style="cursor: pointer;">
            <h4>{{applicationName}}</h4>
        </div>
        <span class="spacer"></span>
        <div class="buttons">
            @if(applicationNameDisplay && (isMobileBuilder || isWebBuilder)) {
                <button mat-button *ngIf="[appPermissions.publish,permissionsActions.read] | builderPermissions" (click)="openPublish()"><i class="icon mdi mdi-publish"></i> Publish</button>
            }
            <div [matMenuTriggerFor]="menu" class="profile">
                <div class="avatar">
                    <h1>
                        {{userInfo?.username[0] | titlecase}}
                    </h1>
                </div>
                {{userInfo?.username}}
                <mat-icon>expand_more</mat-icon>
            </div>
            <mat-menu #menu="matMenu">
                <button mat-menu-item *ngIf="!requriedActions" (click)="changePassword()"> <mat-icon>lock_reset</mat-icon>Change Password</button>
                <button mat-menu-item class="example-icon" (click)="logout()" color="warm" aria-label="Example icon-button with lock icon">
                    <mat-icon>logout</mat-icon> Logout
                </button>
            </mat-menu>
        </div>
      
    </mat-toolbar> 
</div>